import { EventEmitter } from 'events';
import dispatcher from './dispatcher';
import {
  DID_LOGIN,
  DISMISS,
  DID_LOGOUT,
  ON_ERROR,
} from '../store_actions/Actions';

class UserStore extends EventEmitter {
  constructor() {
    super();
    this.user = undefined;
    this.is_updated = false;
    this.login_id = undefined;
    this.activated = false;
    this.error = undefined;
  }

  viewUser() {
    return this.user;
  }

  checkRegistred() {
    return this.is_updated;
  }

  getLoginId() {
    return this.login_id;
  }

  handleActions(action) {
    switch (action.type) {
      case DID_LOGIN:
        this.user = action.payload;
        localStorage.setItem('app_token', action.payload.token);
        this.emit('login');
        break;
      case DID_LOGOUT:
        this.user = undefined;
        localStorage.setItem('app_token', '');
        this.emit('login');
        break;
      case ON_ERROR:
        this.error = action.payload;
        this.emit('error');
      case DISMISS:
        this.is_updated = false;
        this.emit('change');
        break;
    }
  }
}

const userStore = new UserStore();

dispatcher.register(userStore.handleActions.bind(userStore));

export default userStore;
